import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-title',{attrs:{"title":_vm.$t('results.title')}}),_c(VTabs,{attrs:{"background-color":"primary","show-arrows":""}},[_c(VTabsSlider),_vm._l((this.races),function(i){return _c(VTab,{key:i.name,on:{"click":function($event){return _vm.selectRace(i)}}},[_vm._v("\n      "+_vm._s(i.name)+"\n    ")])})],2),_c(VContainer,{attrs:{"fluid":""}},[_c(VRow,{attrs:{"align":"center","justify":"center"}},[_c(VCol,{attrs:{"cols":"12","xs":"12","md":"10"}},[_c('ResultsCard',{attrs:{"race":_vm.selectedRace}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }